const NoTripsMessage = () => (
  <span className="no-trips">
    <h3>Go ahead and create your first trip! :)</h3>
  </span>
);

export default NoTripsMessage;
